import React from 'react'

export default function AnamnesisSection({ title, fields, form, setForm }) {
  return (
    <section className="surface-card form-section">
      <h3>{title}</h3>
      <div className="grid cols-2">
        {fields.map(([field, label]) => (
          <textarea
            key={field}
            className="input textarea"
            placeholder={label}
            value={form[field]}
            onChange={(e) => setForm({ ...form, [field]: e.target.value })}
          />
        ))}
      </div>
    </section>
  )
}
